// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0254ce24","223":"2518b466","380":"470d54e3","453":"8a316ac6","586":"88cf1ce7"}[chunkId] + ".chunk.js";
};